if (!customElements.get('read-more')) {
  class ShowMore extends HTMLElement {
    connectedCallback() {
      const contentSelector = this.dataset.contentHandle;
      const content = this.querySelector(contentSelector);
      const showMore = this.querySelector('[data-button-more]');
      const showLess = this.querySelector('[data-button-less]');

      if (!content || !showMore || !showLess) {
        return;
      }

      this._content = content;
      this._showMore = showMore;
      this._showLess = showLess;
      this._auto = this.dataset.readMoreAuto === 'true';
      this._collapsedPx = null;
      this._noToggle = false;

      const rootRem = () => parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;

      const parseRemAttr = (name, fallback) => {
        const v = parseFloat(this.dataset[name] || '');
        return Number.isFinite(v) ? v : fallback;
      };

      this._minPx = parseRemAttr('readMoreMinRem', 12) * rootRem();
      this._maxPx = parseRemAttr('readMoreMaxRem', 40) * rootRem();
      this._ratio = parseRemAttr('readMoreRatio', 0.52);
      this._blocks = parseInt(this.dataset.readMoreBlocks || '0', 10) || 0;
      const vh = parseFloat(this.dataset.readMoreVhFrac || '');
      this._vhFrac = Number.isFinite(vh) && vh > 0 && vh <= 1 ? vh : 0.42;

      let resizeT;
      const scheduleMeasure = () => {
        clearTimeout(resizeT);
        resizeT = setTimeout(() => this._measureAndApply(), 80);
      };

      if (this._auto) {
        this._measureAndApply();
        if (typeof ResizeObserver !== 'undefined') {
          this._ro = new ResizeObserver(() => {
            if (content.classList.contains('expanded')) return;
            scheduleMeasure();
          });
          this._ro.observe(content);
        }
        window.addEventListener('resize', scheduleMeasure);
      }

      showMore.addEventListener('click', () => {
        if (this._noToggle) return;
        content.classList.add('expanded');
        content.style.maxHeight = '';
        showMore.classList.add('hidden');
        showLess.classList.remove('hidden');
      });

      showLess.addEventListener('click', () => {
        if (this._noToggle) return;
        content.classList.remove('expanded');
        if (this._auto && this._collapsedPx != null) {
          content.style.maxHeight = this._collapsedPx + 'px';
        }
        showLess.classList.add('hidden');
        showMore.classList.remove('hidden');

        const offset = 120;
        const topPosition = content.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth',
        });
      });
    }

    _firstBlocksHeight(root, n) {
      if (!n || n < 1) return 0;
      const found = root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,ul,ol,table');
      let total = 0;
      const limit = Math.min(n, found.length);
      for (let i = 0; i < limit; i++) {
        total += found[i].offsetHeight;
      }
      return total;
    }

    _measureAndApply() {
      const content = this._content;
      const showMore = this._showMore;
      const showLess = this._showLess;

      const wasExpanded = content.classList.contains('expanded');

      content.classList.add('expanded');
      content.style.maxHeight = 'none';
      void content.offsetHeight;

      const full = content.scrollHeight;
      const blocksH =
        this._blocks > 0 ? this._firstBlocksHeight(content, this._blocks) + Math.round(0.5 * this._minPx) : 0;

      const vhCap = window.innerHeight * this._vhFrac;
      const ratioH = full * this._ratio;
      let target = Math.max(this._minPx, ratioH);
      if (blocksH > 0) {
        target = Math.max(target, blocksH);
      }
      target = Math.min(full, target, this._maxPx, vhCap);

      if (full <= this._minPx) {
        content.classList.add('expanded');
        content.style.maxHeight = 'none';
        showMore.classList.add('hidden');
        showLess.classList.add('hidden');
        this._noToggle = true;
        this._collapsedPx = null;
        return;
      }

      this._noToggle = false;
      showMore.classList.remove('hidden');
      if (!wasExpanded) {
        showLess.classList.add('hidden');
      }

      this._collapsedPx = Math.ceil(target);

      if (!wasExpanded) {
        content.classList.remove('expanded');
        content.style.maxHeight = this._collapsedPx + 'px';
      }
    }
  }

  customElements.define('read-more', ShowMore);
}
